import i18next from 'i18next';

i18next.addResources('es', 'projects-iirsa', {
  backToHome: 'Volver al Inicio',
  code: 'Código',
  name: 'Nombre',
  stage: 'Etapa',
  sector: 'Sector',
  subsector: 'Subsector',
  countries: 'Países',
  totalInvestmentMin: 'Inversión total (mín.)',
  totalInvestmentMax: 'Inversión total (máx.)',
  totalInvestment: 'Inversión total (USD)',
  projects: 'Proyectos',
  charts: 'Gráficos',
  fundingSource: 'Fuente de Financiamiento',
  status: 'Estado',
  accompaniment: 'Acompañamiento',
  corridors: 'Corredores',
  routes: 'Rutas',
  projectsMin: 'Proyectos (mín.)',
  projectsMax: 'Proyectos (máx.)',
  description: 'Descripción',
  totalInvestmentCsv: 'Inversión total (USD)',
  totalProjects: 'Total proyectos:',
  totalInvestmentLabel: 'Total inversión (USD):',
  viewMap: 'Ver mapa',
  start: 'Inicio',
  analytics: 'Analíticas',
  projectsOf: 'Proyectos de {{name}}',
  exportGoal: 'Objetivo',
  exportScope: 'Alcance',
  exportProjectType: 'Tipo de obra / Acción',
  exportTotalFinancing: 'Monto total del financiamiento',
  exportEndDate: 'Fecha de Finalización',
  exportAmbientalLicense: 'Licencia Ambiental',
  exportStudiesState: 'Estado de los estudios',
  exportStudiesFinished: 'Estudios finalizados',
  exportStudiesAmount: 'Monto de los estudios',
});

i18next.addResources('en', 'projects-iirsa', {
  backToHome: 'Back to Home',
  code: 'Code',
  name: 'Name',
  stage: 'Stage',
  sector: 'Sector',
  subsector: 'Subsector',
  countries: 'Countries',
  totalInvestmentMin: 'Total investment (min.)',
  totalInvestmentMax: 'Total investment (max.)',
  totalInvestment: 'Total investment (USD)',
  projects: 'Projects',
  charts: 'Charts',
  fundingSource: 'Funding Source',
  status: 'Status',
  accompaniment: 'Accompaniment',
  corridors: 'Corridors',
  routes: 'Routes',
  projectsMin: 'Projects (min.)',
  projectsMax: 'Projects (max.)',
  description: 'Description',
  totalInvestmentCsv: 'Total investment (USD)',
  totalProjects: 'Total projects:',
  totalInvestmentLabel: 'Total investment (USD):',
  viewMap: 'View map',
  start: 'Home',
  analytics: 'Analytics',
  projectsOf: 'Projects of {{name}}',
  exportGoal: 'Goal',
  exportScope: 'Scope',
  exportProjectType: 'Project type / Action',
  exportTotalFinancing: 'Total financing amount',
  exportEndDate: 'End date',
  exportAmbientalLicense: 'Environmental license',
  exportStudiesState: 'Studies status',
  exportStudiesFinished: 'Studies completed',
  exportStudiesAmount: 'Studies amount',
});

i18next.addResources('pt', 'projects-iirsa', {
  backToHome: 'Voltar ao Início',
  code: 'Código',
  name: 'Nome',
  stage: 'Etapa',
  sector: 'Setor',
  subsector: 'Subsetor',
  countries: 'Países',
  totalInvestmentMin: 'Investimento total (mín.)',
  totalInvestmentMax: 'Investimento total (máx.)',
  totalInvestment: 'Investimento total (USD)',
  projects: 'Projetos',
  charts: 'Gráficos',
  fundingSource: 'Fonte de Financiamento',
  status: 'Estado',
  accompaniment: 'Acompanhamento',
  corridors: 'Rotas',
  routes: 'Rotas',
  projectsMin: 'Projetos (mín.)',
  projectsMax: 'Projetos (máx.)',
  description: 'Descrição',
  totalInvestmentCsv: 'Investimento total (USD)',
  totalProjects: 'Total projetos:',
  totalInvestmentLabel: 'Total investimento (USD):',
  viewMap: 'Ver mapa',
  start: 'Início',
  analytics: 'Analíticas',
  projectsOf: 'Projetos de {{name}}',
  exportGoal: 'Objetivo',
  exportScope: 'Alcance',
  exportProjectType: 'Tipo de obra / Ação',
  exportTotalFinancing: 'Valor total do financiamento',
  exportEndDate: 'Data de conclusão',
  exportAmbientalLicense: 'Licença ambiental',
  exportStudiesState: 'Estado dos estudos',
  exportStudiesFinished: 'Estudos concluídos',
  exportStudiesAmount: 'Valor dos estudos',
});
